import SectionHeader from "./SectionHeader";

const values = [
  {
    icon: "ri-scales-3-line",
    title: "进度透明",
    desc: "连载中与完结的进度清楚标出，最新话、完整话数一目了然，绝不含糊。",
  },
  {
    icon: "ri-flag-line",
    title: "更新及时",
    desc: "最新话上线第一时间同步，追更进度实时刷新，热门连载不断档。",
  },
  {
    icon: "ri-heart-3-line",
    title: "把读者当朋友",
    desc: "从收藏到续看都只为让你少操心，把更多时间留给看漫画本身的快乐。",
  },
];

const testimonials = [
  {
    name: "追更十年的老漫迷",
    tag: "热血漫重度读者",
    text: "追了好几十部连载，进度老是记混。用了吹雪之后，每部的当前进度和最新话清清楚楚，续看直接跳回原位，太省心了。",
  },
  {
    name: "周末补番的上班族",
    tag: "完结党",
    text: "平时没空追连载，就喜欢找完结漫画一次读完。这里完结作品标得明明白白，话数完整，找起来特别方便。",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2">
          <div>
            <SectionHeader
              tag="关于吹雪"
              title="让每一话的进度都清清楚楚"
              desc="吹雪漫画网是一处专注漫画追更与信息整理的漫画站，把连载中与完结漫画的进度、最新话更新和追更提醒集中到一个清爽的地方。"
            />
            <p className="text-sm leading-relaxed text-foreground-600">
              追更最怕的就是断片——上次读到第几话、有没有更新、完结了没。我们把这些琐事接过来：作品收藏后自动记录追更进度，最新话更新第一时间同步，连载与完结状态一目了然。你只需要专注享受故事本身。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              我们的愿望很简单：让喜欢漫画的人，无论是追连载还是翻完结，都能点开即知、续看即达，追更不迷路，阅读更省心。
            </p>

            <div className="mt-8 grid gap-4 sm:grid-cols-3">
              {values.map((v) => (
                <div key={v.title} className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200">
                  <span className="mb-3 flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                    <i className={`${v.icon} text-lg`}></i>
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-950">{v.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <SectionHeader
              tag="读者口碑"
              title="他们这样说"
              desc="来自追更读者与完结党的真实感受，是我们坚持下去的动力。"
            />
            <div className="space-y-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-lg bg-background-50 p-6 ring-1 ring-background-200">
                  <div className="mb-3 flex items-center gap-1 text-accent-500">
                    {[0, 1, 2, 3, 4].map((s) => (
                      <i key={s} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="text-sm leading-relaxed text-foreground-700">
                    “{t.text}”
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                      <i className="ri-user-3-line"></i>
                    </span>
                    <div>
                      <p className="text-sm font-medium text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.tag}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}